<div class="button-group">
  <button
    mat-button
    (click)="cancel()"
    class="row-button"
    *ngIf="params.context.componentParent.showRowInEditMode(params.node)"
    color="warn">
    <mat-icon class="fa-close"></mat-icon>
  </button>
  <button
    *ngIf="params.context.componentParent.showRowInEditMode(params.node)"
    mat-button
    color="primary"
    acsStopPropagation
    (click)="setRowSelection()"
    class="row-button"
    [disabled]="isButtonDisabled()">
    <mat-icon class="fa-check"></mat-icon>
  </button>

  <button
    *ngIf="params.context.componentParent.showRowInViewMode(params.node) && params.context.componentParent.loadingNode !== params.node.id"
    mat-button
    acsStopPropagation
    (click)="setRowSelection()"
    [disabled]="isButtonDisabled()"
    class="row-button edit-row-button">
    <mat-icon class="fa-pencil"></mat-icon>
  </button>
  <em *ngIf="params.context.componentParent.loadingNode === params.node.id">
    Loading...
  </em>
</div>
